export default "__VITE_ASSET__D5Lxc4px__"